/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import { judgesSelector } from './judgesSlice.js';

import {dataurl} from '../components/paksh-constants.js'


const idSelector = state => state.judge.id;
const itemSelector = state => state.judge.item;

const initialState = {
  isFetching: false,
  failure: false,
  item: {},
  id : "",
};


/*
https://github.com/reduxjs/reselect

Accepts one or more "input selectors" (either as separate arguments or a single array),
a single "output selector" / "result function", and an optional options object,
and generates a memoized selector function.

When the selector is called, each input selector will be called with all of the provided
arguments. The extracted values are then passed as separate arguments to the output selector,
which should calculate and return a final result. The inputs and result are cached for later use.

If the selector is called again with the same arguments, the previously cached result is returned
instead of recalculating a new result.
*/

export const judgeSelector = createSelector(
  idSelector,
  judgesSelector,
  itemSelector,
  (id, items, item) =>
   // return items && items[id] || item;    // THIS WAS CHANGED SO CAN GET detail as list has details missing
     item  // THIS WAS CHANGED SO CAN GET detail as list has details missing
);

export const fetchJudge = (id) => (dispatch, getState) => {
   const state = getState();
  // const judgeInState = state.judges && state.judges.items && state.judges.items[id] && state.judge.item;
  // console.log(id + state.judge.item)
  // judge with id found in state.judges.items, let the calling code know there's nothing to wait for.
  if (state.judge.item && id === state.judge.item.id ) {  // dont refetch if already have judge details
   // dispatch(judgeReceived(state.judge.item));
    // let the calling code know there's nothing to wait for.
    return Promise.resolve();
   }
   else {
    dispatch(judgeRequested(id));
    // fetch judge data given the judge id. also return a promise to wait for.
    // console.log("not judgeInState"  )
    let token = window.localStorage.getItem('token');
  return fetch(`${dataurl}/judges/${id}`,
    {
      headers: {
      //  'Content-Type': 'application/json',
      //  'Access-Control-Allow-Credentials': true
        'x-access-token': token
      },
      //  credentials: 'include',
      method: 'GET',
    })
    .then(res => res.json())
    .then(data => {
      if (data.error) {
        dispatch(judgeFailed(id));
      } else {
        dispatch(judgeReceived(data));
      }
    })
    .catch((e) => dispatch(judgeFailed(id)));
  // }
}

   }

export const judgeSlice = createSlice({
  name: 'judge',
  initialState,
  reducers: {
    judgeRequested(state, action) {
      state.item = null; // reset items
      state.failure = false;
      state.isFetching = true;
      state.id = null;
    },
    judgeReceived(state, action) {
      state.isFetching = false;
      state.failure = false;
      state.item = action.payload
    },
    judgeFailed(state, action) {
      state.item= null;
      state.failure = true;
      state.isFetching = false;
    },
    judgeUpdated(state, action) {
      state.item = action.payload
    },
  },
})

export const { judgeRequested, judgeReceived, judgeFailed, judgeUpdated } = judgeSlice.actions

// Export the slice reducer as the default export
export default judgeSlice.reducer